import React, { useEffect, useRef, useState } from 'react';
import CopyButton from './copy-button';

function HighlightSection({ children, node }: { children: Object, node: any }) {
  const ref = useRef<HTMLElement>(null);
  const [text, setText] = useState('');

  useEffect(() => {
    if (ref.current) {
      const sectionRef = ref.current as HTMLElement;
      setText(sectionRef.innerText);
    }
  }, [ref]);

  return (
    <section className="highlight" ref={ref}
    // data-startline={node.position?.start.line}
    data-endline={node.position?.end.line}
    data-position={node.position?.start.offset}
    data-size={node.position?.end?.offset - node.position?.start.offset}>
      <>
        <CopyButton text={text} className="highlight__copy" />
        {children}
      </>
    </section>
  );
}

export default HighlightSection;
